import "./FAQCard.scss";

interface FAQCardProps {
  header: string;
  children: React.ReactNode;
}

const FAQCard: React.FC<FAQCardProps> = ({ header, children }) => {
  return (
    <div className="faq-card">
      <div className="faq-card-header">{header}</div>
      <div className="faq-card-body">{children}</div>
    </div>
  );
};

export default FAQCard;
